import { useMutation, useQueryClient } from "@tanstack/react-query"
import client from "@/api/client"
import { CONVERSATIONS_QUERY_KEY } from "./useInfiniteConversationsQuery"

export const useDeleteConversationMutation = (options?: {
  onSuccess?: () => void
  onError?: () => void
}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (conversationId: string) => {
      return client.api.aiAgentControllerDeleteConversation(conversationId)
    },
    onSuccess: () => {
      // Invalidate the conversations list query to trigger a refetch
      queryClient.invalidateQueries({ queryKey: CONVERSATIONS_QUERY_KEY })
      options?.onSuccess?.()
    },
    onError: () => {
      options?.onError?.()
    },
  })
} 